import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

export default function WhatsAppButton() {
  const phone = '34623433546';
  const message =
    'Hola, dinos en qué podemos ayudarte, puedes enviarnos un mensaje o nota de voz con tu consulta y te contestaremos con la mayor brevedad posible.';
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  const controls = useAnimation();

  useEffect(() => {
    let scrollTimeout: NodeJS.Timeout;
    const onScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        controls.start({
          x: [-2, 2, -2, 2, 0],
          transition: { duration: 0.2, ease: 'linear' },
        });
      }, 300);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(scrollTimeout);
    };
  }, [controls]);

  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      animate={controls}
      className="fixed bottom-6 left-6 z-50 bg-green-500 text-white rounded-full p-4 shadow-xl hover:bg-green-600 transition-colors duration-300 hover:scale-110"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Contactar por WhatsApp"
    >
      {/* Logo PNG real, mismo tamaño que antes */}
      <img
        src="/icons8-whatsapp-240.png"
        alt="WhatsApp"
        className="w-7 h-7 object-contain"
      />
    </motion.a>
  );
}